import * as React from 'react';
import * as styles from '../view-segment.module.scss';
import {
  SegmentAttributeOperator,
  SegmentCompositionSelection,
  SegmentDetailParsedAttributeGroup
} from '../../../models/segments';
import clsx from 'clsx';
import ViewAttribute from './view-attribute';
import ViewAttributeGroup from './view-attribute-group';
import SegmentIncludeExcludeHeader from '../segment-include-exclude-header';
import { findBaseAttributeId } from '../../../utilities/attribute-filter';
import ViewCompositionSelection from './view-composition-selection';

interface Props {
  includedAttributes: SegmentDetailParsedAttributeGroup;
  excludedAttributes: SegmentDetailParsedAttributeGroup;
  includeComposition: SegmentCompositionSelection;
  excludeComposition: SegmentCompositionSelection;
}

/**
 * Render the segment attributes table in a view-only segment
 */
const ViewSegmentAttributes = ({
  includedAttributes,
  excludedAttributes,
  includeComposition,
  excludeComposition
}: Props) => {
  const firstAttributeLabel = (attributes: SegmentDetailParsedAttributeGroup) =>
    JSON.stringify(attributes) === JSON.stringify(includedAttributes) ? 'Base Attribute' : 'Exclude';

  const isExclude = (attributes: SegmentDetailParsedAttributeGroup) =>
    JSON.stringify(attributes) === JSON.stringify(excludedAttributes);

  const includedAtt = {
    attributes: JSON.parse(JSON.stringify(includedAttributes)),
    composition: { ...includeComposition }
  };

  const excludedAtt = {
    attributes: JSON.parse(JSON.stringify(excludedAttributes)),
    composition: { ...excludeComposition }
  };
  return (
    <>
      {[includedAtt, excludedAtt].map(
        (segmentAttributes) =>
          segmentAttributes && (
            <React.Fragment key={isExclude(segmentAttributes.attributes) ? 'include' : 'exclude'}>
              <SegmentIncludeExcludeHeader isNew={false} exclude={isExclude(segmentAttributes.attributes)} />
              {!!segmentAttributes.composition?.segmentId && (
                <ViewCompositionSelection composition={segmentAttributes.composition} />
              )}
              <div className={styles.tableWrapper}>
                {segmentAttributes.attributes.predicates.map((predicate, idx) => (
                  <ul className={styles.attributeRow} key={`${findBaseAttributeId(predicate)}-${idx}`}>
                    <li className={clsx(styles.baseOperator, idx != 0 && styles.operator)}>
                      {idx == 0
                        ? firstAttributeLabel(segmentAttributes.attributes)
                        : SegmentAttributeOperator[segmentAttributes.attributes.operator]}
                    </li>
                    {'attributeId' in predicate ? (
                      <ViewAttribute attribute={predicate} depth={0} />
                    ) : (
                      <ViewAttributeGroup attributeGroup={predicate} depth={0} />
                    )}
                    {'customers' in predicate && (
                      <li
                        className={styles.customers}
                      >{`${predicate.customers.toLocaleString()} customers meet criteria`}</li>
                    )}
                  </ul>
                ))}
              </div>
            </React.Fragment>
          )
      )}
    </>
  );
};

export default ViewSegmentAttributes;
